import { createSelector } from 'reselect'

const getSignupData = state => state.signup

const sendEmailForm = createSelector(
	[ getSignupData ],
	signupData => {
		let obLessonData
		if (signupData.obLessonData.obEntityType && signupData.obLessonData.obEntityType !== 'B') {
			obLessonData = signupData.obLessonData
		}
		return {
			isTeacher: signupData.isTeacher,
			obLessonData,
		}
	}
)

export default sendEmailForm
